import React from "react";
import './Button.css'

function Button
    (
        {
            key,
            clickMethod,
            buttonName,
            disabled,
            style,
            type
        }
    ) {

    return (
        <button
            key={key}
            className='button-field'
            onClick={() => { clickMethod() }}
            disabled={disabled}
            style={{ cursor: 'pointer', ...style }}
            type={type}
        >
            {buttonName}
        </button>
    );
}

export default Button;
